import React from "react";
import CustomTable from "../../components/CustomTable";
import { get } from "../../../store/actions/CommonActions";
import { GET_SHOWS } from "../../../store/actions/ActionTypes";
import dummyimage from "../../../images/dummyimage.jpeg";
import "./style.css";
import { formatDate, formatTime } from "../../../utils/functions/date";
import { getImageUrl } from "../Artist/ArtistAvatar";
import ShowFilter from "./ShowFilter";
export const ShowBlockUI = ({ data }) => {
  return (
    <div className="show-block-ui">
      <div className="show-banner-image">
        <img src={data?.project?.squareImage ? getImageUrl(data?.project?.squareImage) : dummyimage} lazyload />
      </div>
      <div className="show-banner-details">
        <div className="show-title fw-bold">{data?.project?.conceptTitle ?? '-'}</div>
        <div className="show-category">
          {data?.project?.artForm?.name ?? '-'}
          {data?.project?.artForm?.name && data?.project?.genre?.name ? ` | ${data.project.genre.name}` : null}
        </div>
      </div>
    </div>
  );
};
const Shows = () => {
  const getLatestDate = (schedules) => {
    const now = new Date();
    if (!schedules || schedules.length <= 0) {
      return <>-</>;
    }
    const upcoming = schedules
      .map((obj) => ({
        ...obj,
        dateTime: new Date(`${obj.date}T${obj.start_time}`), // combine to Date object
      }))
      .filter((obj) => obj.dateTime > now) // only future ones
      .sort((a, b) => a.dateTime - b.dateTime); // sort ascending by date

    const result =
      upcoming.length > 0 ? upcoming[0] : schedules[schedules.length - 1];
    return (
      <>
        <span className="fw-bold">{formatDate(result.date)}</span>
        <br />
        <span>
          {`${formatTime(result?.start_time)} - ${formatTime(
            result?.end_time
          )}`}
        </span>
      </>
    );
  };
  const getHook = (data) => {
    return (dispatch) => {
      dispatch(get("schedule", data, GET_SHOWS));
    };
  };
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage = 1, pageSize = 10) => {
        const seq = (currentPage - 1) * pageSize + index + 1;
        return (
          <>
            <span className="fw-bold">{seq}</span>
            <br />
            <span className="fw-bold">
              {row?.schedule_code ?? '-'}
            </span>
            <br />
            <span>
              <span style={{ color: '#BE282D' }}>{row?.initiative?.title ?? '-'}</span>
              <span> - {row?.show_number ?? '-'}</span>
            </span>
          </>
        );
      },
    },
    {
      label: "Show",
      // key: "city",
      render: (row, index) => {
        return <ShowBlockUI data={row} />;
      },
      // subKey: 'name'
    },
    {
      label: "Artist",
      render: (row, index) => {
        return row?.project?.artist ? (
          <>
            <span className="fw-bold">
              {row?.project?.artist?.firstName} {row?.project?.artist?.lastName}
              <br />
            </span>
            <span>
              {
                `${row?.project?.artist?.age ? `${row?.project?.artist?.age}, ` : ""}
                ${row?.project?.artist?.gender ? `${row?.project?.artist?.gender},` : ""}
                ${row?.project?.artist?.city?.name ? `${row?.project?.artist?.city?.name}` : ""}
            `}
            </span>
          </>
        ) : "-";
      },
    },
    {
      label: "Date & Time",
      render: (row, index) => {
        return (
          <>
            <span className="fw-bold">{formatDate(row.date)}</span>
            <br />
            <span>
              {`${formatTime(row?.start_time)} - ${formatTime(
                row?.end_time
              )}`}
            </span>
          </>
        );
      },
    },
    {
      label: "Venue",
      render: (row, index) => {
        // Debug: Log the row data to see the actual structure
        return (
          <>
            <span className="fw-bold">
              {row?.performanceVenue?.title ?? '-'}
            </span>
            <br />
            <span>{row?.venue?.title ?? '-'}</span>
          </>
        );
      },
    },
  ];
  return (
    <CustomTable
      title="Shows"
      columns={columns}
      getHook={getHook}
      store={"show"}
      search={true}
      filterIcon={true}
      FilterComponent={ShowFilter}
      // addBtnTitle="Create New Show"
      deleteHook={"schedule"}
    />
  );
};

export default Shows;
